export const customerModel = {
    firstName: '',
    middleName: '',
    lastName: '',
    sex: '',
    mobile: '',
    phone1Desc: '',
    home: '',
    phone2Desc: '',
    work: '',
    phone3Desc: '',
    addrHouse: '',
    addrStreet: '',
    addrUnit: '',
    addrCity: '',
    addrProvince: '',
    addrCountry: 'Canada',
    addrPostal: '',
    email: '',
    healthcard: '',
    birthdate: '',
    communicationType: 'none',
    marketingEmailOptin: false,
    emailNotifications: true,
    smsNotifications: false,
    // communicationPreferences: [{
    //     id: null,
    //     customerId: null,
    //     preferenceType: '',
    //     channel: '',
    //     optIn: false,
    //     consentTimestamp: null,
    //     consentSource: '',
    //     stampUser: null,
    //     createdAt: null,
    //     updatedAt: null
    // }],
    comment: '',
    familyId: null,
};